import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

let hasBooted = false;

export const rememberRouteGuard: CanActivateFn = (route, state) => {
	if (hasBooted) {
		return true;
	}

	hasBooted = true;

	const localStorage = inject(LocalStorageService);

	// See if there's already a stored destination route
	const storedRouteParts = localStorage.getLoginDestination(false);

	// If we already have a route stored we don't want to override it
	// we'll eventually redirect to it.
	if (storedRouteParts && storedRouteParts.length > 0) {
		return true;
	}

	// Get route parts as an array
	const destination = state.url;

	// Save the destination to local storage
	localStorage.saveLoginDestination(destination);

	return true;
};
